import { Lock } from "lucide-react";

/**
 * Editorial product placeholder — restricted fashion archive feel.
 * Minimal: emblem watermark, faint metadata, no terminal clutter.
 */
export default function PlaceholderArt({ label = "GARMENT FILE", sku = "", locked = false }) {
  return (
    <div
      data-testid="placeholder-art"
      className={`relative aspect-[4/5] w-full overflow-hidden ${
        locked ? "file-card-locked" : "bg-[#0a0316]"
      }`}
    >
      {/* Soft radial vignette */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[80%] aspect-square rounded-full blur-[80px] bg-[#ff1493] opacity-[0.08]" />
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[55%] aspect-square rounded-full blur-[60px] bg-[#9d4cdd] opacity-[0.16]" />
      </div>

      {/* Hairline scan — very subtle */}
      <div
        className="absolute inset-0 opacity-15 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(135deg, rgba(255,20,147,0.10) 0px, rgba(255,20,147,0.10) 1px, transparent 1px, transparent 12px)",
        }}
      />

      {/* Brand emblem watermark — large, centered */}
      <img
        src="/brand/emblem.png"
        alt=""
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[58%] max-w-[240px] opacity-[0.22] pointer-events-none select-none"
        style={{ filter: "drop-shadow(0 0 50px rgba(255,20,147,0.6))" }}
        draggable={false}
      />

      {locked && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 translate-y-12">
          <Lock size={22} strokeWidth={1.25} className="text-[#ff3b30]" />
        </div>
      )}

      {/* Bottom-left: tiny brand mark */}
      <div className="absolute bottom-4 left-5 flex items-center gap-2 font-mono text-[10px] tracking-[0.24em] uppercase text-[#b4a3c7]">
        <span className="w-1 h-1 bg-[#ff1493] rounded-full" />
        FEMBOT NEX
      </div>

      {/* Bottom-right: file code */}
      {sku && (
        <div className="absolute bottom-4 right-5 font-mono text-[10px] tracking-[0.24em] text-[#7a6a90]">
          {sku}
        </div>
      )}

      {/* Optional centered label — only when explicitly provided & emphasized */}
      {label && (
        <div className="absolute top-5 left-5 font-mono text-[10px] tracking-[0.28em] uppercase text-[#7a6a90]">
          // {label}
        </div>
      )}
    </div>
  );
}
